import React from 'react';
import { Card, CardContent, Divider, Box, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import PostStatus from '../Shared/PostStatus/PostStatus';
import PostIndicators from '../Shared/PostIndicators';
import { PostCategories } from '../../../Utils/Types';
import { isPostComing, postHasParent } from '../../../Utils/Post';
import InteractionsBox from '../Shared/InteractionsBox';
import PostSideHeader from '../Show/PostSideHeader';
import { getPostSideHeaderTextID } from './utils';
import Budget from '../Shared/Budget/Budget';
import UserVotesInfo from '../Shared/UserVotesInfo/UserVotesInfo';
import { allStepsEnded } from '../../../Utils/Steps';

function PostSidePrimaryActions({ post, space }: any) {
  const isMessaging = PostCategories.MESSAGING.includes(post.type);
  const parent = post.included.source || {};
  const isPostClosedForParticipation = postHasParent(post) && allStepsEnded(post);
  const isComing = !postHasParent(post) && isPostComing(post);
  const canVote = post.actions?.find((action: any) => action.name === 'vote_support');

  return (
    <Card>
      {(isPostClosedForParticipation || isComing) && (
        <PostSideHeader i18nKey={getPostSideHeaderTextID(isPostClosedForParticipation)} />
      )}

      <CardContent>
        <Box sx={{ mb: 2 }}>
          <PostStatus post={post} />
        </Box>

        <Box sx={{ mb: 2 }}>
          <Divider />
        </Box>

        {post.voting_options && post.meta && canVote && (
          <Box sx={{ mb: 2 }}>
            {/* Idea view */}

            <UserVotesInfo post={post} parent={parent} space={space} />
          </Box>
        )}

        {post.budget && (
          <Box sx={{ mb: 2 }}>
            <Budget post={post} space={space} />
          </Box>
        )}

        {isMessaging && (
          <Typography color="textPrimary" variant="body2" sx={{ mb: 2 }}>
            <FormattedMessage id="COMMENTS.CREATE.PRIVACY_WARNING" />
          </Typography>
        )}

        <Box sx={{ mb: 3 }}>
          <InteractionsBox
            post={post}
            space={space}
            ctaVariant="contained"
            direction="column"
            onlyPrimaryActions
          />
        </Box>

        {post.post_contributions_stats && (
          <Box sx={{ mt: 2 }}>
            <PostIndicators postContributionsStats={post.post_contributions_stats} />
          </Box>
        )}
      </CardContent>
    </Card>
  );
}

export default PostSidePrimaryActions;
